import { Dismiss } from '@wix/wix-ui-icons-common';
import React, { FC } from 'react';

import { dismissCopilot } from '../../../messageChannel/postNewMessages';

export const CancelButton: FC<{}> = (props) => {
  return <Dismiss onClick={dismissCopilot} style={{ cursor: 'pointer' }} />;
};
